import type { TypographyProps } from "@mui/material/Typography";
import { ValueUnitUnit, ValueUnitValue } from "./ValueUnit.components";

interface ValueUnitProps {
  value: string;
  unit: string;
  slotProps?: {
    value?: TypographyProps;
    unit?: TypographyProps;
  };
}

function ValueUnit(props: ValueUnitProps) {
  const { value, unit, slotProps } = props;

  return (
    <ValueUnitValue variant="TextXXL" {...slotProps?.value}>
      {value}{" "}
      <ValueUnitUnit component="span" {...slotProps?.unit}>
        {unit}
      </ValueUnitUnit>
    </ValueUnitValue>
  );
}

export default ValueUnit;
